module.exports = __webpack_public_path__ + "img/bl.4d724b8e.svg";